import { useQuery } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { getConfig } from '../clients/configClient';
import { Config } from '../common/types';

interface ConfigContextType {
  isLoading: boolean;
  config: Config;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

// Default config w. fallback values
const defaultConfig: Config = {
  plusPlanSubscriptionPrice: '19.99',
  plusPlanSubscriptionLink: 'https://buy.stripe.com/14A7sM4vA9NF4NHb8D24004'
};

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const {
    data: config,
    isLoading,
    isError
  } = useQuery({
    queryKey: ['getConfig'],
    queryFn: getConfig,
    retry: 3
  });

  const finalConfig = isError ? defaultConfig : config;

  return (
    <ConfigContext.Provider value={{ config: finalConfig || defaultConfig, isLoading }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfigContext = (): ConfigContextType => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfigContext must be used within a ConfigProvider');
  }
  return context;
};
